import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { appQueryClient as queryClient } from "../../shared/state/appQueryClient";
import { useUserLoggedInStatus } from "../../shared/state/user";

const sendRequestToRecordUserVisitPage = async (pathname) => {
  try {
    await queryClient.fetchQuery({
      staleTime: 0,
      queryKey: [
        "recordUserVisitPage",
        {
          action: "recordUserVisitPage",
          fetchOptions: { method: "POST" },
          body: {
            page: pathname,
            version: process.env.REACT_APP_TAG || "Unknown",
          },
          enabled: true,
        },
      ],
    });
  } catch (error) {
    console.error("record user visit page failed", error);
  }
};

export const RecordUserVisitPage = () => {
  const location = useLocation();
  const isLoggedIn = useUserLoggedInStatus();

  useEffect(() => {
    window.scrollTo(0, 0);

    const pathname = location.pathname;
    const isLogoutPage = pathname === "/logout";

    if (isLoggedIn && !isLogoutPage) {
      sendRequestToRecordUserVisitPage(pathname);
    }
  }, [location.pathname, isLoggedIn]);

  return null;
};
